export default __webpack_public_path__ + "static/media/cart-shape.d8504f76.svg";